import { headerStyles as styles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        margin-top: 20px;
        margin-bottom: 20px;
    `,
};

styles.totalText = {
    ...styles.totalText,
    css: css`
        ${styles.totalText?.css}
        ${mediaQueriesBP.maxMD} {
            margin-top: 8px;
        }
    `,
};

styles.sharingStatus = {
    ...styles.sharingStatus,
    statusText: {
        css: css`
            order: 3;
            padding-left: 30px;
            ${mediaQueriesBP.maxMD} {
                margin-top: 8px;
            }
        `,
    },
    privateTooltip: {
        ...styles.sharingStatus?.privateTooltip,
        mergeCss: true,
    },
};
